import { useEffect, useState } from "react";
import api from "./api";
import { categories as fallback } from "../mock";

let cache = null;
const subs = new Set();
export const refreshCategories = () => api.get("/categories").then(({ data }) => { cache = [{ id: "all", label: "Tutti i prodotti", image: null }, ...data]; subs.forEach((f) => f(cache)); }).catch(() => {});

export const useCategories = () => {
  const [cats, setCats] = useState(cache || fallback);
  useEffect(() => { subs.add(setCats); if (!cache) refreshCategories(); return () => subs.delete(setCats); }, []);
  return cats;
};
